import { Button, Col, Row, Space, Typography } from "antd";
import { InputOTP } from "antd-input-otp";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { OnBoarding } from "~/Components";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { apiBaseUrl, post } from "~/Services";
import { xApiKey } from "~/Utils/Constants";
import { defaultRedirectURL } from "~/Utils/StringConstants";

const { Title, Text, Link } = Typography;

export const OtpLoginPage = () => {
  const [inputValue, setInputValue] = useState<any>();
  const query = useQuery();
  const [isLoading, setIsLoading] = useState(false);
  const email = query.get("emailAddress");
  const isApi = query.get("api");
  const isFirstTimeuser = query.get("firstTimeUser");
  const [user, setUser] = useLocalStorage("user", null);
  const [xAuthProvider, setxAuthProvider] = useLocalStorage("authProvider", "internal");
  const { openToast } = useNotification();
  const [timer, setTimer] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [timer]);

  useEffect(() => {
    if (isApi) {
      setTimer(60);
    }
  }, [isApi]);

  const handleOtpVerification = () => {
    const payload = {
      email: email,
      code: Array.isArray(inputValue) ? inputValue.join("") : inputValue,
    };
    setIsLoading(true);
    post("auth/verify-login-otp", payload,{  "X-Auth-Type": "manual" })
      .then((res: any) => {
        const token = res?.response?.data?.token;
        const refreshToken = res?.response?.data?.refreshToken;
        const accessTokenExpiry = res?.response?.data?.accessTokenExpiry;
        const refreshTokenExpiry = res?.response?.data?.refreshTokenExpiry;

        if (isFirstTimeuser === "true") {
          navigate(`/auth/new-password?emailAddress=${email}`);
          setIsLoading(false)
          return;
        }

        axios
          .get(`${apiBaseUrl}/user/userprofile/access`, {
            withCredentials: true,
            headers: {
              "X-Auth-Provider": "local",
              "x-api-key": xApiKey,
//              "X-Auth-Type": "manual",
            },
          })
          .then(({ data }: any) => {
            setxAuthProvider("local");
            if (data.response) {
              setUser({
                email: data.response.data.emailAddress,
                name: data.response.data.name,
                refreshToken: "", // Token stored in cookie only
                token: "", // Token stored in cookie only, not localStorage
                access: data.response.data.access,
                role: data.response.data.role,
                isRequestedStatus: data.response.data.isUserOnboardApproved,
                status: data.response.data.status,
                isActive: data.response.data.isActive,
              });
              let access = data.response.data.access;
              let role: any = data.response.data.role;
              let requestStatus: any = data.response.data.isUserOnboardApproved;
              let isActive: any = data.response.data.isActive;

              // let access = ["MAGP_REVIEWER"];
              if (!access && isActive === false) {
              } else if (!access && isActive === null) {
                window.location.pathname = defaultRedirectURL("WELCOME_PAGE");
              } else if (role) {
                window.location.pathname = defaultRedirectURL("MODULE_SELECTION");
              } else {
                window.location.pathname = defaultRedirectURL("WELCOME_PAGE");
              }
            }
          })
          .catch(() => {
            openToast({ content: "Something went wrong!", type: "error" });
          });
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false)
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleOtp = () => {
    post(`auth/request-otp?email=${email}`, null, { "X-Auth-Type": "manual"  })
      .then((res: any) => {
        const message = res?.message;
        openToast({ content: message, type: "success" });
        setTimer(60);
      })
      .catch((err) => {
        const message = err?.message;
        // openToast({ content: message, type: "error" });
      });
  };
  return (
    <>
      <OnBoarding>
        <div style={{ width: "340px" }}>
          <Row style={{ marginBottom: 25 }}>
            <Col span={24}>
              <Title level={2}>Enter OTP</Title>
            </Col>
          </Row>
          <Row>
            <Space
              direction="vertical"
              size="middle"
            >
              <Text>We just sent a otp to your Email Address*</Text>{" "}
              <InputOTP
                type="text"
                inputType="numeric"
                value={inputValue}
                onChange={(e) => setInputValue(e)}
              />
            </Space>
          </Row>
          <Row style={{ marginTop: 10, justifySelf: "center" }}>
            <Col span={24}>
              {" "}
              <Link
                onClick={timer === 0 ? handleOtp : undefined}
                disabled={timer > 0}
              >
                Resend OTP {timer > 0 && `(In ${timer}sec)`}
              </Link>
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Button
              loading={isLoading}
              type="primary"
              block
              size="large"
              htmlType="submit"
              onClick={handleOtpVerification}
              disabled={!inputValue || inputValue.length < 6}
            >
              Continue
            </Button>
          </Row>
        </div>
      </OnBoarding>
    </>
  );
};
